// USD formatters/parsers for the note amounts (InputNumber). Moved verbatim from pages/PropertyDetails.js
// so the shared form sections can use them without importing a page.
export const locale = 'en-us';

export const currencyFormatter = (value) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};

export const currencyFormatterNoDecimal = (value) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(value);
};

export const currencyParser = (val) => {
  try {
    // for when the input gets clears
    if (typeof val === 'string' && !val.length) {
      val = '0.0';
    }

    // detecting and parsing between comma and dot
    let group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, '');
    let decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, '');
    let reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');

    // removing everything except the digits and dot
    reversedVal = reversedVal.replace(/[^0-9.]/g, '');

    // appending digits properly
    const digitsAfterDecimalCount = (reversedVal.split('.')[1] || []).length;
    const needsDigitsAppended = digitsAfterDecimalCount > 2;

    if (needsDigitsAppended) {
      reversedVal = reversedVal * Math.pow(10, digitsAfterDecimalCount - 2);
    }

    return Number.isNaN(reversedVal) ? 0 : reversedVal;
  } catch (error) {
    console.error(error);
  }
};

export const currencyParserNoDecimal = (val) => {
  try {
    if (typeof val === 'string' && !val.length) {
      val = '0';
    }

    let group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, '');

    let reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');

    reversedVal = reversedVal.replace(/[^0-9]/g, '');

    return Number.isNaN(reversedVal) ? 0 : reversedVal;
  } catch (error) {
    console.error(error);
  }
};
